export const CATEGORY_EDIT_DIALOG_ATTRIBUTE = 'data-category-edit-dialog';

/**
 * `onInteractOutside` handler for menus that open CategoryEditDialog: the dialog is portaled outside
 * the menu, so clicks in it would otherwise close the menu and unmount the dialog.
 */
export function keepOpenWhileEditingCategory(event: {
  target: EventTarget | null;
  preventDefault: () => void;
}) {
  const clickedInsideDialog =
    event.target instanceof Element &&
    event.target.closest(`[${CATEGORY_EDIT_DIALOG_ATTRIBUTE}]`) !== null;
  if (clickedInsideDialog) event.preventDefault();
}
